import { object, string } from "yup";

export type FormValues = {
  userTag?: string | null;
};

export const validationSchema = object({
  userTag: string().notRequired().nullable(),
});
